<template>
  <div>
    <server-error :error="error" />

    <div v-if="reportTableData && reportTableData.errors" data-cy="server-error">
      <div v-for="(er, index) in reportTableData.errors" :key="index" class="b-server-error mt-4 mx-6">
        <div class="b-server-error__icon-wrap p-4">
          <dynamic-icon icon="warning"></dynamic-icon>
        </div>
        <div class="b-server-error__text-wrap px-4"><span v-html="buildReportErrorMessage(er)"></span></div>
      </div>
    </div>


    <div v-if="isLoaded">
      <div v-if="reportTableData !== null">
        <button class="b-btn mx-6" @click="exportReportData">
          <dynamic-icon class="b-btn__icon" icon="xls"></dynamic-icon>
          {{ $t('CONTENT.reportPage.download_excel') }}
        </button>
        <div class="b-reports__table-wrapper">
          <div class="b-full-table b-reports__table-wrap mt-4">
            <!--          Шапка-->
            <div class="b-reports__table-header-wrap">
              <!--            <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">-->
              <!--              Филиал-->
              <!--            </div>-->
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.contract_code') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.id_contract') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.comment') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.lessor') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.lessor_type') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.contract_number') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.contract.contract_date') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.asset_name') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.asset_type') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.business_unit_number') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.business_unit_name') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.inventory_number') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.asset_component_share_external_id') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.spi') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.spi_on_end_date') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.assets.lease_start_date') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.assets.lease_end_date') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.reportPage.lessee') }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $tc('CONTENT.currency.currency_code', 1) }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{ $t('CONTENT.discountRates.discount_rate') }}
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{ $t('CONTENT.reportPage.initial_cost') }}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.initial_cost_start_cost') }}
                  </div>
                  <div class="b-reports__table-header-block-wrap b-reports__table-header-block-wrap--inner">
                    <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                      {{ $t('CONTENT.reportPage.initial_cost_initial_recognition_cost') }}
                    </div>
                    <div class="b-reports__table-header-block-inner">
                      <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell b-reports__table-header-cell--first-inner">
                        {{ $t('CONTENT.reportPage.total_initial_cost_initial_recognition_cost') }}
                      </div>
                      <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{ $t('CONTENT.reportPage.lease obligations_initial_recognition_cost') }}
                      </div>
                      <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{ $t('CONTENT.reportPage.payments_initial_recognition_cost') }}
                      </div>
                      <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{ $t('CONTENT.reportPage.expenses_initial_recognition_cost') }}
                      </div>
                      <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                        {{ $t('CONTENT.reportPage.future_expenses_initial_recognition_cost') }}
                      </div>
                    </div>
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.adjustment_increase') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.adjustment_decrease') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.disposal') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.initial_recognition_correction') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.initial_cost_transferred_cost') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.initial_cost_end_cost') }}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{ $t('CONTENT.reportPage.cumulative_amortization') }}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.amortization_sum_before_period') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.amortization_sum_in_period') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.adjustment_decrease') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.disposal') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.amortization_correction') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.amortization_transferred_cost') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.amortization_sum_on_period_end') }}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{ $t('CONTENT.reportPage.report_devaluation') }}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.cost_before_devaluation') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.devaluation_sum_before_period') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.devaluation_in_period') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.devaluation_recovery_in_period') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.adjustment_decrease') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.disposal') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.devaluation_correction') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.devaluation_transferred_cost') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.devaluation_sum_on_period_end') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.cost_after_devaluation') }}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{ $t('CONTENT.reportPage.lease_liability_part') }}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lease_liability_part_start_liability') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lease_liability_part_initial_recognition_liability') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.adjustment_increase') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lease_liability_part_percentage_loss') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.adjustment_decrease') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lease_liability_part_lease_payments_in_period') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lease_liability_part_accumulated_currency_rate_difference') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.liability_correction') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.liability_lease_payments_correction') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lease_liability_part_transferred_cost') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lease_liability_part_end_liability') }}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{ $t('CONTENT.reportPage.additional_info_part') }}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.additional_info_part_remaining_lease_payments') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.additional_info_part_remaining_long_payments') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.additional_info_profit') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.additional_info_loss') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.additional_info_profits_and_losses') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.additional_infopart_correction') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.lessor_change_date') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.responsible') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.extensionOption') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.terminationOption') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.buyoutOption') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.spiMonthCountInitialRecognition') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.eventNumber') }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{ $t('CONTENT.reportPage.eventComment') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="b-reports__table-content-wrap">
              <!--          Филиалы-->
              <div class="b-reports__table-row" v-for="item in reportTableData.rows">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >{{item.subsidiary}}-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.contractCode }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell b-full-table__cell-name" @click="editContractById(item.contractCode)"
                >{{ item.externalSystemId }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.contractCommentary }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ getCounterpartyName(item.lessorId) }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ $t(`CONTENT.reportPage.${item.counterpartyType}`) }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.contractNumber }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.contractDate | dateFormatted }}
                </div>
                <div class="b-full-table__cell b-reports__table-cell">
                  {{ item.assetName.toLowerCase() !== item.assetComponentName.toLowerCase()
                  ? `${item.assetName}${item.assetComponentName !== null ? ' - ' + item.assetComponentName : ''}`
                  : item.assetName
                  }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ getAssetType(item.underlyingAssetTypeId) }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.businessUnitExternalId }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.businessUnitName }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.assetComponentExternalId }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.assetComponentSharesExternalId }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.spiMonthCount }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.remainingSpiMonthCount }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.leaseStartDate | dateFormatted }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.leaseEndDate | dateFormatted }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ getCounterpartyName(item.lesseeId) }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{ getFullCurrency(item.currencyRateType) }}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{ item.discountRate }}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.startCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.initialRecognitionCost.total) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.initialRecognitionCost.liability) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.initialRecognitionCost.paymentBeforeStartDate) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.initialRecognitionCost.firstExpense) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.initialRecognitionCost.backlog) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.adjustmentsIncrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.adjustmentsDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.initialCost.endCost) }}
                  </div>
                </div>

                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.amortization.amortizationSumBeforePeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.amortization.amortizationSumInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.amortization.adjustmentDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.amortization.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.amortization.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.amortization.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.amortization.amortizationSumOnPeriodEnd) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.costBeforeDevaluation) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.devaluationSumBeforePeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.devaluationInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.devaluationRecoveryInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.adjustmentsDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.devaluationSumOnPeriodEnd) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.devaluation.costAfterDevaluation) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.startLiability) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.initialRecognitionLiability) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.adjustmentIncrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.percentageLoss) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.adjustmentDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.leasePaymentsInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.accumulatedCurrencyRateDifference) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.leaseLiabilityPart.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.leaseLiabilityPart.leasePaymentsInPeriodCorrection) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.leaseLiabilityPart.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.leaseLiabilityPart.endLiability) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.additionalInfoPart.remainingLeasePayments) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.additionalInfoPart.longTermRemainingLeasePayments) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.additionalInfoPart.adjustmentIncrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.additionalInfoPart.adjustmentDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(item.additionalInfoPart.accumulatedDisposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(item.additionalInfoPart.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > <span v-if="item.lessorChangeDates && item.lessorChangeDates.length > 0">
                      <div v-for="(date, index) in item.lessorChangeDates" :key="index">
                        {{ date | dateFormatted }}
                      </div>
                    </span>
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ item.responsible || "—" }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ item.extension !== true ? "Нет" : "Да" }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ item.termination !== true ? "Нет" : "Да" }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ item.buyout !== true ? "Нет" : "Да" }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ item.spiMonthCountInitialRecognition}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ item.eventNumber}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ item.eventComment}}
                  </div>
                </div>
              </div>
              <!--          Итого-->
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{ $t('CONTENT.reportPage.related_parties_total') }}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.startCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.initialRecognitionCost.total)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.initialRecognitionCost.liability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.initialRecognitionCost.paymentBeforeStartDate)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.initialRecognitionCost.firstExpense)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.initialRecognitionCost.backlog)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.adjustmentsIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.adjustmentsDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.endCost) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.amortizationSumBeforePeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.amortizationSumInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.amortizationSumOnPeriodEnd)
                    }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.costBeforeDevaluation)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationSumBeforePeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationRecoveryInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.adjustmentsDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationSumOnPeriodEnd)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.costAfterDevaluation)
                    }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.startLiability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.initialRecognitionLiability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.adjustmentIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.percentageLoss)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.leasePaymentsInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.accumulatedCurrencyRateDifference)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.correction)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.leasePaymentsInPeriodCorrection)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.transferredCost)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.endLiability)
                    }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.remainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.longTermRemainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.adjustmentIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.accumulatedDisposal)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{
                      convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.correction)
                    }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.relatedPartiesTotal.lessorChangeDate }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.relatedPartiesTotal.responsible }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{ $t('CONTENT.reportPage.total_for_third_party_companies') }}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.startCost)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.initialRecognitionCost.total)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.initialRecognitionCost.liability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.initialRecognitionCost.paymentBeforeStartDate)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.initialRecognitionCost.firstExpense)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.initialRecognitionCost.backlog)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.adjustmentsIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.adjustmentsDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.disposal)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.endCost) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.amortizationSumBeforePeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.amortizationSumInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.disposal)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.amortizationSumOnPeriodEnd)
                    }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.costBeforeDevaluation)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationSumBeforePeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationRecoveryInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.adjustmentsDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.disposal)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{  convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.correction)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{  convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.transferredCost)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationSumOnPeriodEnd)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.costAfterDevaluation)
                    }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.startLiability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.initialRecognitionLiability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.adjustmentIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.percentageLoss)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.leasePaymentsInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.accumulatedCurrencyRateDifference)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.correction)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.leasePaymentsInPeriodCorrection)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.transferredCost)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.endLiability)
                    }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.remainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.longTermRemainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.adjustmentIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.accumulatedDisposal)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.totalForThirdPartyCompanies.lessorChangeDate }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.totalForThirdPartyCompanies.responsible }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{ $t('CONTENT.reportPage.total_for_vgo') }}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.startCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.initialRecognitionCost.total) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.initialRecognitionCost.liability) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.initialRecognitionCost.paymentBeforeStartDate) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.initialRecognitionCost.firstExpense) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.initialRecognitionCost.backlog) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.adjustmentsIncrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.adjustmentsDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.endCost) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.amortizationSumBeforePeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.amortizationSumInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.adjustmentDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.amortizationSumOnPeriodEnd)
                    }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.costBeforeDevaluation) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationSumBeforePeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationRecoveryInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.adjustmentsDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{  convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.correction)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{  convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.transferredCost)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationSumOnPeriodEnd)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.costAfterDevaluation) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.startLiability) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.initialRecognitionLiability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.adjustmentIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.percentageLoss) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.leasePaymentsInPeriod)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.accumulatedCurrencyRateDifference)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.correction)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.leasePaymentsInPeriodCorrection)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.transferredCost)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.endLiability) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.remainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.longTermRemainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.adjustmentIncrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.adjustmentDecrease)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.accumulatedDisposal)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.correction) }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.totalForVgo.lessorChangeDate }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.totalForVgo.responsible }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--          <div-->
                <!--            class="b-full-table__cell b-reports__table-cell"-->
                <!--          >-->
                <!--          </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{ $t('CONTENT.reportPage.total') }}
                </div>

                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.startCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.initialRecognitionCost.total) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.initialRecognitionCost.liability) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.initialRecognitionCost.paymentBeforeStartDate) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.initialRecognitionCost.firstExpense) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.initialRecognitionCost.backlog) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.adjustmentsIncrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.adjustmentsDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.total.initialCost.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.total.initialCost.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.initialCost.endCost) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.amortization.amortizationSumBeforePeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.amortization.amortizationSumInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.amortization.adjustmentDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.amortization.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.total.amortization.correction) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{ convertDecimalToStringForChart(reportTableData.total.amortization.transferredCost) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.amortization.amortizationSumOnPeriodEnd) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.devaluation.costBeforeDevaluation) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationSumBeforePeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationRecoveryInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.devaluation.adjustmentsDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.devaluation.disposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{  convertDecimalToStringForChart(reportTableData.total.devaluation.correction)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  > {{  convertDecimalToStringForChart(reportTableData.total.devaluation.transferredCost)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationSumOnPeriodEnd) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.devaluation.costAfterDevaluation) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.startLiability) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.initialRecognitionLiability)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.adjustmentIncrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.percentageLoss) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.adjustmentDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.leasePaymentsInPeriod) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.accumulatedCurrencyRateDifference)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.correction)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.leasePaymentsInPeriodCorrection)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{  convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.transferredCost)  }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.endLiability) }}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.remainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{
                      convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.longTermRemainingLeasePayments)
                    }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.adjustmentIncrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.adjustmentDecrease) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{ convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.accumulatedDisposal) }}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{ convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.correction) }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.total.lessorChangeDate }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell">
                    {{ reportTableData.total.responsible }}
                  </div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                  <div class="b-full-table__cell b-reports__table-cell"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>

import ReportsAPI from "../api/ReportsAPI";
import convertDecimalForChart from "@/utils/converters/convert.decimal.for.chart";
import {mapGetters} from "vuex";
import getFullCurrency from "../../../mixins/getFullCurrency";
import buildReportErrorMessage from "../../../mixins/buildReportErrorMessage";
import NotificationList from "../../../components/shared/NotificationList.vue";

export default {
  components: {
    NotificationList
  },
  props: {
    dataForReport: {
      type: Object,
    },
    nonActiveContractIds: {
      type: Array,
    },
    fillDiscountRateNotificationIds: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      error: null,
      errors: null,
      reportTableData: null,
      isHideLeasePaymentsGroupColumns: false,
      isHideInitialRecognitionColumns: false,
    };
  },
  async created() {
    await this.formReport(this.dataForReport);
  },
  watch: {
    dataForReport: {
      handler(newVal) {
        this.formReport(newVal);
      },
      deep: true
    },
  },
  mixins: [getFullCurrency, buildReportErrorMessage],
  computed: {
    ...mapGetters(['allCounterparties']),
    ...mapGetters(['getUnderlyingAssetTypes']),
  },
  methods: {
    async formReport(data) {
      try {
        this.$loadingManager.addLoadingStep();
        this.error = null;
        this.reportTableData = null;
        this.reportTableData = await new ReportsAPI().getDecryptionReportBasedOnAssetsAndExpenses({
          periodStart: data.periodStart,
          periodEnd: data.periodEnd,
          takeEventsBeforeDate: data.takeEventsBeforeDate,
          contractId: data.contractId,
          lesseeId: data.lesseeId
        });
        this.$parent.nonActiveContractIds = this.reportTableData.nonActiveContractIds;
        this.$parent.discountRateNotifications = this.reportTableData.discountRateNotifications;
        this.fillDiscountRateNotificationIds(this.reportTableData.discountRateNotifications, false);
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },

    convertDecimalToStringForChart(decimal) {
      return convertDecimalForChart(decimal);
    },

    editContractById(id) {
      const routeData = this.$router.resolve({ name: 'AssetsEdit', params: {id}})
      window.open(routeData.href, '_blank')
    },

    async exportReportData() {
      this.error = null;
      this.errors = null;
      try {
        const api = new ReportsAPI();
        const response = await api.exportResultOfDecryptionReportBasedOnAssetsAndExpenses(this.reportTableData);


        let filename = null;
        let filenameInURI = null;

        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if (item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
    },
    getCounterpartyName(counterpartyId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === counterpartyId) {
          return this.allCounterparties[i].displayName;
        }
      }
    },
    getAssetType(assetTypeId) {
      for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
        if (this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
          return this.getUnderlyingAssetTypes[i].name;
        }
      }
    },
  }
};
</script>
